import { Icon } from "@nexus/ui"
import { useTranslation } from "react-i18next"

export interface ClearFiltersButtonProps {
  onClear: () => void
}

/** Companion to `FiltersToggleButton` — resets every facet filter in the toolbar. */
export function ClearFiltersButton({ onClear }: ClearFiltersButtonProps) {
  const { t } = useTranslation()

  return (
    <button
      type="button"
      onClick={onClear}
      className="flex h-9 shrink-0 items-center gap-1 rounded-md px-2 text-xs font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground sm:h-8"
    >
      <Icon name="x" size="xs" />
      {t("common.clearFilters")}
    </button>
  )
}
